import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function InvitePage() {
  const { invitationCode } = useParams();
  const navigate = useNavigate();
  console.log('Invitation code from URL:', invitationCode);

  useEffect(() => {
    if (!invitationCode) return;

    const fetchToken = async () => {
      try {
        let url = `${process.env.REACT_APP_URL}/api/users/invite/${invitationCode}`;
        const response = await fetch(url);
        if (!response.ok) {
          // Handle errors (not found, expired)
          return navigate('/error');
        }

        const data = await response.json();
        const fullToken = data.token;

        // Redirect to real registration page with full token
        navigate(`/invite/${fullToken}`);
      } catch (err) {
        console.error(err);
        navigate('/error');
      }
    };

    fetchToken();
  }, [invitationCode, navigate]);

  return <div>Redirecting...</div>;
}
